import { render } from "./ShowMoreButton.vue?vue&type=template&id=4762c5fe&scoped=true"
import script from "./ShowMoreButton.vue?vue&type=script&lang=js"
export * from "./ShowMoreButton.vue?vue&type=script&lang=js"

import "./ShowMoreButton.vue?vue&type=style&index=0&id=4762c5fe&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4762c5fe"]])

export default __exports__